import { Record } from 'immutable';

import { PermissionList } from '../../core/domain/permission-list.entity';

export const PermissionSliceKey = 'permissions';

interface IPermissionSliceState {
	all: PermissionList;
}

const defaults: IPermissionSliceState = {
	all: PermissionList.build(),
};

export class PermissionSliceState extends Record<IPermissionSliceState>(
	defaults
) {
	public static readonly key = PermissionSliceKey;

	public setPermissionList(permissions: PermissionList): PermissionSliceState {
		return this.set('all', permissions);
	}
}
